/**
 * MainPageErrorHandler.js
 * 
 * This utility adds error handling to the main booking page to prevent
 * constant refreshing due to map loading issues.
 */

// Flag to prevent duplicate initialization
let isInitialized = false;

/**
 * Initialize error handling for the main booking page
 * to prevent constant refreshing due to map loading issues
 */
function initializeErrorHandling() {
  // Only initialize once
  if (isInitialized) {
    return;
  }
  isInitialized = true;

  console.log('Initializing error handling for main booking page');

  // Only run on the main booking page
  if (window.location.pathname !== '/') {
    return;
  }

  // KEEP IT SIMPLE - No error handling on main page to match standalone page
  console.log('Keeping main page simple - no error handling like standalone page');
}

// Auto-initialize if this is the main booking page
if (typeof window !== 'undefined' && window.location.pathname === '/') {
  initializeErrorHandling();
}

export default initializeErrorHandling; 